// src/components/Header/Header.js
// import React, { useState } from 'react';
// import './Header.css';

// const Header = ({ activeSection, scrollToSection }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <header className="header">
//       <div className="container">
//         <a href="#home" className="logo">Habiba Shahidi</a>
//         <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
//           <ul className="nav-list">
//             {['home', 'about', 'skills', 'projects', 'contact'].map(item => (
//               <li key={item}>
//                 <a 
//                   href={`#${item}`} 
//                   className={activeSection === item ? 'active' : ''}
//                   onClick={(e) => {
//                     e.preventDefault();
//                     scrollToSection(item);
//                   }}
//                 >
//                   {item.charAt(0).toUpperCase() + item.slice(1)}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </nav>
//         <button className="menu-toggle" onClick={toggleMenu}>
//           <span></span>
//           <span></span>
//           <span></span>
//         </button>
//       </div>
//     </header>
//   );
// };

// export default Header;


// src/components/Header/Header.js
import React, { useState, useEffect } from 'react';
import { Code2, Sparkles, Menu, X } from 'lucide-react';
import './Header.css';

const Header = ({ activeSection, scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' }
  ];

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          {/* Logo */}
          <div className="logo" onClick={() => handleNavClick('home')}>
            <div className="logo-icon">
              <Code2 size={24} />
              <div className="sparkle">
                <Sparkles size={10} />
              </div>
            </div>
            <div className="logo-text">
              <span className="logo-name">Habiba Shahidi</span>
              <span className="logo-tag">Software Developer</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul>
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                    onClick={() => handleNavClick(item.id)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className={`mobile-menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(false)} />
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-header">
          <div className="mobile-logo">
            <Code2 size={20} />
            <span>Habiba Shahidi</span>
          </div>
        </div>
        <nav className="mobile-nav">
          <ul>
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  className={`mobile-nav-link ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => handleNavClick(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;